<template>
  <div class="production" :class="{ 'has-highlight-color': highlight }">
    <div class="production__season" v-if="production.seasonTitle">
      {{ production.seasonTitle }}
    </div>
    <div class="production__dates" v-if="production.dateStart">
      <DateTime :date="production.dateStart" :end="production.dateEnd" />
    </div>
    <div class="production__artists">{{ production.artists }}</div>
    <div class="production__title">{{ production.title }}</div>
    <div class="production__subtitle">{{ production.subtitle }}</div>
    <div class="production__meta">
      <ul class="production__taxonomies">
        <li v-for="genre in production.genres" :key="genre._id">
          {{ genre }}
        </li>
        <li v-if="production.productionType" key="type">
          {{ production.productionType }}
        </li>
      </ul>
      <div
        v-if="images && (production.images || []).length"
        class="production__images"
      >
        <figure v-for="image in production.images" :key="image._key">
          <ResponsiveImage :image="image" :ratio="false" />
        </figure>
        <button @click="scrollToImage(production.images[0])">
          <span>Bilder zeigen</span>
        </button>
      </div>
      <div v-if="link && production.url" class="production__link">
        <a :href="production.url">→ Details auf <span>brut-wien.at</span></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import DateTime from '@/components/DateTime.vue'
import ResponsiveImage from '@/components/ResponsiveImage.vue'

export default {
  name: 'ProductionInfo',
  props: {
    production: {
      type: Object,
      required: true
    },
    link: {
      type: Boolean,
      default: false
    },
    images: {
      type: Boolean,
      default: false
    },
    highlight: {
      type: Boolean,
      default: true
    }
  },
  components: { DateTime, ResponsiveImage },
  computed: {
    ...mapGetters(['isproductionHighlighted']),
    highlighted() {
      return this.isproductionHighlighted(this.production)
    },
    seasons() {
      return []
    }
  },
  methods: {
    scrollToImage(image) {
      const selector = `[data-media-scroll-anchor='${image._key}']`
      const content = document.querySelector(selector)
      if (content) {
        content.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    }
  }
}
</script>

<style scoped>
.production {
  position: relative;
}
.production.has-highlight-color {
  &:hover {
    /* color: var(--color-highlight); */
  }
  .production__season {
    color: var(--color-highlight);
  }
}
.production__season {
  @mixin type-smaller;
  font-weight: 600;
}
.production__dates {
  @mixin type-medium--serif;
}
.production__artists {
  @mixin type-larger--serif;
}
.production__title {
  @mixin type-larger;
  font-weight: 600;
}
.production__subtitle {
  @mixin type-larger;
}
.production__meta {
  display: flex;
  flex-wrap: wrap;
  padding-top: 0.6em;
  padding-left: var(--content-indent);
}
.production__taxonomies {
  flex: 0 0 100%;
  @mixin type-smallest;
  li {
    display: inline-block;
    padding-right: 3em;
    &:last-child {
      padding-right: 0;
    }
  }
}
.production__images {
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;
  padding-top: 0.5em;
  figure {
    margin-right: 3px;
  }
  button {
    position: absolute;
    top: -0.5em;
    left: -0.5em;
    right: -0.5em;
    bottom: -0.3em;
    width: calc(100% + 1em);
    height: calc(100% + 0.8em);
    opacity: 0.1;
    border-radius: 0.3em;
    outline: none;
    transition: 200ms background-color;
    &:focus {
      background-color: var(--color-text);
    }
    span {
      @mixin hide-visually;
    }
  }
}
/deep/ .production__images {
  img {
    height: 40px;
    width: auto;
    width: calc(40px * var(--aspect-ratio, 1));
    object-fit: cover;
  }
}
.production__link {
  position: relative;
  flex: 0 0 100%;
  @mixin type-smaller;
  span {
    text-decoration: underline;
  }
  a {
    padding-top: 0.3em;
    display: inline-block;
  }
}
@media only print {
  .production {
    display: inline-block;
    width: 100%;
    page-break-inside: avoid;
  }
}
</style>
